import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOMetadata = ({ 
  title = "",
  description = "",
  keywords = "",
  ogTitle = "",
  ogDescription = "",
  ogImage = "",
  path = "",
  noindex = false
}) => {
  const siteTitle = "AI-переводчик @lngaua_bot";
  const siteDescription = "Переводчик текста и голоса в реальном времени для Telegram";
  const siteUrl = process.env.REACT_APP_BACKEND_URL?.replace('/api', '') || window.location.origin;
  
  const finalTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const finalDescription = description || siteDescription;
  const finalOgTitle = ogTitle || title || siteTitle;
  const finalOgDescription = ogDescription || description || siteDescription;
  const finalOgImage = ogImage || `${siteUrl}/og-image.jpg`;
  const canonicalUrl = `${siteUrl}${path}`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": siteTitle,
    "description": siteDescription,
    "url": siteUrl,
    "sameAs": ["https://t.me/lngaua_bot"]
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="AI-переводчик @lngaua_bot" />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      <meta name="twitter:image" content={finalOgImage} />

      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="Russian" />
      <meta name="geo.region" content="RU" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEOMetadata;
